import Loading from '../../../../Dashboards/Common/Loading';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';
import { WithoutIncentivesAnual } from './WithoutIncentivesAnual';
import { WithoutIncentivesMonthly } from './WithoutIncentivesMonthly';
import { TotalIncentivesAnual } from './TotalIncentivesAnual';
import { TotalIncentivesMonthly } from './TotalIncentivesMonthly';
import { CalculatedValueWithIncentivesAnual } from './CalculatedValueWithIncentivesAnual';
import { CalculatedValueWithIncentivesMonthly } from './CalculatedValueWithIncentivesMonthly';
import { TransferValueComparisonAnual } from './TransferValueComparisonAnual';
import { TransferValueComparisonMonthly } from './TransferValueComparisonMonthly';
import { TransferValueComparisonPercentualAnual } from './TransferValueComparisonPercentualAnual';
import { TransferValueComparisonPercentualMonthly } from './TransferValueComparisonPercentualMonthly';

export const Charts = () => {
    const { isLoading } = useValuesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <WithoutIncentivesAnual />
                <WithoutIncentivesMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <TotalIncentivesAnual />
                <TotalIncentivesMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <CalculatedValueWithIncentivesAnual />
                <CalculatedValueWithIncentivesMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <TransferValueComparisonAnual />
                <TransferValueComparisonMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <TransferValueComparisonPercentualAnual />
                <TransferValueComparisonPercentualMonthly />
            </div>     
        </>
    );
};
